<template>
    <mdb-navbar id="home" :color="'primary'" position="top" dark href="#" transparent scrolling>
        <mdb-container>
<!--            <mdb-navbar-brand><strong><a v-scroll-to="'#home'" class="text-uppercase" style="font-size: large">Worcester Polytechnic Institue & <br/>Army Research Lab</a></strong></mdb-navbar-brand>-->
            <router-link to="/#app"><mdb-navbar-brand><strong><a >WPI-ARL</a></strong></mdb-navbar-brand></router-link>
            <mdb-navbar-toggler style="max-width: 1140px">
                <mdb-navbar-nav right class="nav-items">
                    <router-link to="/#aboutus"><mdb-nav-item waves-fixed>About Us</mdb-nav-item></router-link>
                    <router-link to="/#projects"><mdb-nav-item waves-fixed>Projects</mdb-nav-item></router-link>
                    <router-link to="/#publications"><mdb-nav-item waves-fixed>Publications</mdb-nav-item></router-link>
                    <router-link to="/#datasets"><mdb-nav-item waves-fixed>Datasets</mdb-nav-item></router-link>
                    <router-link to="/#funding"><mdb-nav-item waves-fixed>Funding</mdb-nav-item></router-link>
                    <router-link to="/#members"><mdb-nav-item waves-fixed>Members</mdb-nav-item></router-link>
                    <router-link to="/#contactus"><mdb-nav-item waves-fixed>Contact US</mdb-nav-item></router-link>
                </mdb-navbar-nav>
                <!--Search form -->
<!--                <mdb-navbar-nav right>-->
<!--                    <form>-->
<!--                        <mdb-input type="text" class="text-white f-flex" placeholder="Search" aria-label="Search" navInput waves waves-fixed/>-->
<!--                    </form>-->
<!--                </mdb-navbar-nav>-->
                <!--/.Search form -->
            </mdb-navbar-toggler>
        </mdb-container>
    </mdb-navbar>
</template>

<script>
    import {
        mdbContainer,
        mdbNavbar,
        mdbNavbarToggler,
        mdbNavbarNav,
        mdbNavItem,
        mdbNavbarBrand
    } from 'mdbvue';

    import Vue from 'vue';
    import VueScrollTo from 'vue-scrollto';

    Vue.use(VueScrollTo)
    VueScrollTo.install(Vue, {
        offset: -50,
    })

    // VueScrollTo.setDefaults({
    //     container: "body",
    //     duration: 500,
    //     easing: "ease",
    //     offset: 0,
    //     force: true,
    //     cancelable: true,
    //     onStart: false,
    //     onDone: false,
    //     onCancel: false,
    //     x: false,
    //     y: true
    // })


    export default {
        name: 'NavBar',
        components: {
            mdbContainer,
            mdbNavbar,
            mdbNavbarToggler,
            mdbNavbarNav,
            mdbNavItem,
            mdbNavbarBrand
        }
    }
</script>

<style>
    .navbar .md-form {
        margin: 0;
    }

    .top-nav-collapse {
        background-color: #000000 !important;
    }

    .navbar-toggler{
        right: 10px;
        top:10px;
        position: absolute;
    }

    @media (max-width: 990px) {
        .navbar {
            background-color: #000000 !important;
        }
    }

    .nav-items{

        text-transform: uppercase;
        font-weight: 400;
        letter-spacing: 0.12em;
        font-size: small;

    }
</style>
